<bringoz-icon class="margin-0 bringoz-icon-16 pointer"
             (click)="toggle(); $event.stopPropagation()"
             [iconName]="isExpanded ? 'chevron-up' : 'chevron-down'"
             [ngbTooltip]="!isMobile ? (tooltipText || 'Show More' | translate) : null"
             openDelay="300"
             triggers="hover"
             container="body">
</bringoz-icon>
